import { type ReactNode } from 'react';

import {
  MentionChipContent,
  mentionChipClassName,
  mentionChipTitle,
} from '@/features/mention';
import { useGroupsQuery } from '@/features/people-wiki/groups/groups.query';
import { cn } from '@/lib/utils';

import { GroupAvatars } from './group-avatars';
import { groupToMention } from './group-mention-source';

/** A tagged group in a sent message, drawn like the composer's chip. A group that no longer exists stays text. */
export const GroupMentionChip = ({
  groupName,
  children,
}: {
  groupName: string;
  children: ReactNode;
}) => {
  const { data: groups } = useGroupsQuery({ enabled: false });
  const group = groups?.find(({ name }) => name === groupName);
  if (!group) return <span>{children}</span>;

  const mention = groupToMention(group);
  return (
    <span
      // not-prose: the message's prose styles give every img block margins, which push the avatars out of the chip
      className={cn(mentionChipClassName(), 'not-prose select-text')}
      title={mentionChipTitle(mention)}
    >
      <MentionChipContent
        mention={mention}
        icon={<GroupAvatars groupName={group.name} sizeClassName="size-4" />}
      />
    </span>
  );
};
